import React from 'react';

import OiStyledButton from '../../../../shared/components/Common/OiButton/OiStyledButton';
import NotificationBell from '../../../../shared/components/NotificationBell';
import BackHomeNavigation from '../../../../shared/components/BackHomeNavigation';

const TopNav = ({ isToggled, toggledAppMode, merchantCategory }) => {
    const category = merchantCategory?.name.split(' ')[0];

    return (
        <header className="oi-topnav">
            <div
                className={`${isToggled ? 'oi-topnav__section--compact' : 'oi-topnav__section--mod'} oi-topnav__section`}>
                {!navigator.onLine && (
                    <div
                        style={{
                            width: '100%',
                            height: 20,
                            display: 'flex',
                            flex: 1,
                            background: 'red',
                            alignItems: 'center',
                            justifyContent: 'center'
                        }}>
                        <h4 style={{ fontSize: 14, fontWeight: 'bold', color: 'white', textAlign: 'center' }}>
                            You are currently offline
                        </h4>
                    </div>
                )}
                <BackHomeNavigation />

                <div className="oi-sub-settings">
                    <div className="oi-btn__containers">
                        {/* I am still working here! */}
                        {category !== undefined ? (
                            <OiStyledButton
                                color="secondary"
                                title={category}
                                styles="oi-btn--height32 || oi-btn--radius50 || oi-btn__hide-mobile || oi-btn__sans-click || u-padx_2 || u-magx_18r"
                            />
                        ) : (
                            ''
                        )}

                        <OiStyledButton
                            color="grey"
                            title={toggledAppMode}
                            styles="oi-btn--height32 || oi-btn--radius50 || oi-btn__hide-mobile || oi-btn__sans-click || u-padx_2 || u-magx_24r"
                        />
                    </div>
                    <div className="oi-btn__divider" />
                    <NotificationBell />
                </div>
            </div>
        </header>
    );
};

export default TopNav;
